"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREATOR_EVENT_TOUCHCANCEL = exports.CREATOR_EVENT_TOUCHEND = exports.CREATOR_EVENT_TOUCHMOVE = exports.CREATOR_EVENT_TOUCHSTART = exports.CREATOR_EVENT_CLICK = exports.CREATOR_EVENT_OUT = exports.CREATOR_EVENT_LEAVE = exports.CREATOR_EVENT_MOVE = exports.CREATOR_EVENT_UP = exports.CREATOR_EVENT_DOWN = void 0;
var EVENT_CREATOR_EVENT_DOWN = 'mousedown';
var EVENT_CREATOR_EVENT_UP = 'mouseup';
var EVENT_CREATOR_EVENT_MOVE = 'mousemove'; // Overwrite for MS touch support

if (typeof window !== 'undefined') {
  if (window.navigator.pointerEnabled) {
    EVENT_CREATOR_EVENT_DOWN = "pointerdown";
    EVENT_CREATOR_EVENT_UP = "pointerup";
    EVENT_CREATOR_EVENT_MOVE = "pointermove";
  } else if (window.navigator.msPointerEnabled) {
    EVENT_CREATOR_EVENT_DOWN = 'MSPointerDown';
    EVENT_CREATOR_EVENT_UP = 'MSPointerUp';
    EVENT_CREATOR_EVENT_MOVE = 'MSPointerMove';
  }
}

var CREATOR_EVENT_DOWN = EVENT_CREATOR_EVENT_DOWN;
exports.CREATOR_EVENT_DOWN = CREATOR_EVENT_DOWN;
var CREATOR_EVENT_UP = EVENT_CREATOR_EVENT_UP;
exports.CREATOR_EVENT_UP = CREATOR_EVENT_UP;
var CREATOR_EVENT_MOVE = EVENT_CREATOR_EVENT_MOVE;
exports.CREATOR_EVENT_MOVE = CREATOR_EVENT_MOVE;
var CREATOR_EVENT_LEAVE = 'mouseleave';
exports.CREATOR_EVENT_LEAVE = CREATOR_EVENT_LEAVE;
var CREATOR_EVENT_OUT = 'mouseout';
exports.CREATOR_EVENT_OUT = CREATOR_EVENT_OUT;
var CREATOR_EVENT_CLICK = 'click';
exports.CREATOR_EVENT_CLICK = CREATOR_EVENT_CLICK;
var CREATOR_EVENT_TOUCHSTART = 'touchstart';
exports.CREATOR_EVENT_TOUCHSTART = CREATOR_EVENT_TOUCHSTART;
var CREATOR_EVENT_TOUCHMOVE = 'touchmove';
exports.CREATOR_EVENT_TOUCHMOVE = CREATOR_EVENT_TOUCHMOVE;
var CREATOR_EVENT_TOUCHEND = 'touchend';
exports.CREATOR_EVENT_TOUCHEND = CREATOR_EVENT_TOUCHEND;
var CREATOR_EVENT_TOUCHCANCEL = 'touchcancel';
exports.CREATOR_EVENT_TOUCHCANCEL = CREATOR_EVENT_TOUCHCANCEL;